import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";


const Chapter2 = () => {
const selectedLanguage = useSelector((state) => state.language.language);
      const [language, setLanguage] = useState(SinhalaData[0]);
    
        useEffect(() => {
            switch (selectedLanguage.value) {
              case "english":
                setLanguage(EnglishData[0]);
                break;
              case "tamil":
                setLanguage(TamilData[0]);
                break;
              default:
                setLanguage(SinhalaData[0]);
                break;
            }
          }, [selectedLanguage]);
        

    return (
        <>
            {/* Chapter 2 */}
            <section id="section2" className="drivers-handbook-section">
                <h2 className="drivers-handbook-heading">
                    {language.chapter2Title}
                
                </h2>

                <p className="drivers-handbook-paragraph">
                    {language.chapter2Paragraph1}
                </p>

                <p className="drivers-handbook-paragraph">
                    {language.chapter2Paragraph2}
                </p>

                <p className="drivers-handbook-paragraph">
                    {language.chapter2Paragraph3}
                </p>

                <p className="drivers-handbook-paragraph">
                     {language.chapter2Paragraph4}
                </p>

                <p className="drivers-handbook-paragraph">
                    {language.chapter2Paragraph5}
                </p>

                <p className="drivers-handbook-paragraph">
                    {language.chapter2Paragraph6}
                </p>
                <div className="image-box">
                    <img src={language.chapter2Image1} alt="Chapter 2" />
                </div>

                <p className="drivers-handbook-paragraph">
                    {language.chapter2Paragraph7}
                </p>

                <p className="drivers-handbook-paragraph">
                    {language.chapter2Paragraph8}
                </p>
            </section>
        </>
    )

}

export default Chapter2;
